import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';
import { isEmptyObject } from './isEmptyObject';

export const getSaveContactSettings = ({
  saveContactFullName,
  saveContactJobTitle,
  saveContactCompany,
  saveContactPhoneNumber,
  saveContactEmail,
  saveContactWebSite,
  saveContactAddress,
  saveContactImage
}: Partial<ChatsChannelBase>) => {
  const vcardSettings = {
    name: saveContactFullName,
    job: saveContactJobTitle,
    company: saveContactCompany,
    image: saveContactImage?.url,
    phone: saveContactPhoneNumber,
    address: saveContactAddress,
    email: saveContactEmail,
    website: saveContactWebSite
  };

  if (isEmptyObject(vcardSettings)) {
    return null;
  }

  return {
    provider: ChatsChannelType.savecontact,
    link: {
      vcardSettings,
      options: { openCurrentPage: true }
    },
    title: 'Save Contact',
    icon: getChatIcon(ChatsChannelType.savecontact),
    color: 'rgb(0, 0, 0)'
  } as ChatsChannelSetting;
};
